// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"e4407926","56":"cb29098f","95":"bc6dc3fd","632":"14316de5"}[chunkId] + ".chunk.js";
};